import React from 'react';
import { Link } from 'react-router-dom';
import { LoadingCard } from 'adc-ui-components';
import Check from './svgs/Check';
import BoxClosed from './svgs/BoxClosed';
import Bill from './svgs/Bill';
import Devices from './svgs/Devices';
import DismissIcon from './svgs/DismissIcon';
import Outage from './svgs/Outage';
import Truck from './svgs/Truck';
import Exclamation from './svgs/Exclamation';

const ICON_COMPONENTS = {
  check: Check,
  'box-closed': BoxClosed,
  bill: Bill,
  devices: Devices,
  'outage-no-circle': Outage,
  'icon-bill-white': Bill,
  'icon-truck-white': Truck,
  'icon-exclamation': Exclamation,
};

const isExternalLink = link => /^(https?:)?\/\//.test(link);

const NbaMedia = ({ color, svgIcon }) => {
  const IconComponent = ICON_COMPONENTS[svgIcon];
  return (
    <div className="card__media">
      <div className={`circle circle--${color}`}>
        {IconComponent && <IconComponent />}
      </div>
    </div>
  );
};

const NbaLink = ({
  link, linkText, linkTarget, linkOut,
}) => {
  const content = (
    <>
      {linkText}
      {linkOut && <span className="icon icon-link-out" />}
    </>
  );

  if (isExternalLink(link)) {
    return (
      <a href={link} target={linkTarget} rel="noopener noreferrer">
        {content}
      </a>
    );
  }

  return (
    <Link to={link} target={linkTarget} rel="noopener noreferrer">
      {content}
    </Link>
  );
};

const NextBestActions = ({ nbas = [], onDismiss, loading }) => {
  if (!loading && !nbas.length) return null;

  return (
    loading ? (
      <LoadingCard />
    ) : (
      <div className="next-best-actions" data-tracking='{"container": ["next best actions"]}'>
        <div className="card-group">
          {nbas.map(nba => (
            <div className="card-group__item" key={nba.id}>
              <div
                id={`nba-${nba.id}`}
                className={`card next-best-action card--${nba.color} card--has-media-at-768 card--action-right`}
              >
                <NbaMedia color={nba.color} svgIcon={nba.svgIcon} />

                <div className="card__content">
                  <div className="hgroup">
                    {nba.name && <h4 className="body2">{nba.name}</h4>}
                    {nba.description && <span>{nba.description}</span>}
                    {nba.link && (
                      <NbaLink
                        link={nba.link}
                        linkText={nba.linkText}
                      />
                    )}
                  </div>
                </div>

                {nba.dismissible && (
                  <div className="card__action">
                    <button
                      className="card__dismiss button button--text"
                      type="button"
                      onClick={() => onDismiss(nba.id)}
                    >
                      <DismissIcon />
                      <span className="visuallyhidden">Dismiss</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  );
};

export default NextBestActions;
